import { useState } from "react";
import Modal from "../../../../../../components/base/Modal";

interface WialonTokenModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (token: string) => void;
  currentToken?: string;
  themeClasses: {
    bg: string;
    border: string;
    text: string;
    textSecondary: string;
    cardBg: string;
    cardBorder: string;
    buttonText: string;
    buttonTextHover: string;
    buttonHover: string;
  };
}

export function WialonTokenModal({
  isOpen,
  onClose,
  onSave,
  currentToken = "",
  themeClasses,
}: WialonTokenModalProps) {
  const [token, setToken] = useState(currentToken);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (token.trim()) {
      onSave(token.trim());
      onClose();
    }
  };

  const content = (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className={`block text-sm font-medium mb-2 ${themeClasses.text}`}>
          Token de Wialon
        </label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Ingresa tu token de Wialon"
          className={`w-full px-4 py-2 border ${themeClasses.border} rounded-lg ${themeClasses.bg} ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-blue-500`}
          required
        />
        <p className={`text-xs ${themeClasses.textSecondary} mt-1`}>
          Este token se usará para autenticar las solicitudes a la API de Wialon.
        </p>
      </div>
      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onClose}
          className={`px-4 py-2 border ${themeClasses.border} rounded-lg ${themeClasses.text} hover:bg-gray-100 dark:hover:bg-gray-700`}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Guardar
        </button>
      </div>
    </form>
  );

  if (!isOpen) return null;

  return (
    <Modal
      onClose={onClose}
      title="Configurar Token de Wialon"
      content={content}
      themeClasses={themeClasses}
    />
  );
}
